import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Estado } from './estado.model';

/* DTO basico para representar um estado de qualquer entidade no modelo */
export class Cobranca extends BaseEntity {

    public estado: Estado;

	public tipoCobranca: string;
	public sistema: number;
	public dataEmissaoDaFicha: Date;
	public dataVencimentoDaFicha: Date;
	public dataLimiteParaPagamentoDaFicha: Date;
	public dataPagamentoDaFicha: Date;
	public sequencialDaFicha: number;
	public valorDevidoEmSELIC: number;
	public valorPagoEmSELIC: number;
	public valorPagoEmReais: number;
	public cnpjAgenteFinanceiro: string;
    public nomeAgenteFinanceiro: string;
	public codigoCobranca: number; // este eh o codigo de identificacao da ficha no IBM
	public nomeExtratoCobranca: string;
	public nomeAnexoCobranca: string;
	public indicadorReemissaoSolicitada: boolean;
}

export const TIPO_COBRANCA = [
	{
	  codigo: '1',
	  labelAbreviado: 'ECG',  
	  labelCompleto: 'Encargo de concessão de garantia'
	},
	{ 
	  codigo: '2',
	  labelAbreviado: 'Rec. Credt.',
	  labelCompleto: 'Recuperação de crédito'
	},
	{
	  codigo: '3',
	  labelAbreviado: 'Indenização', // = a.k.a. Cancelamento de Garantia (honrada),
	  labelCompleto: 'Cobrança de indenização (cancelamento de garantia)'
	},
	{
	  codigo: '4',
	  labelAbreviado: 'Dev. Honra',
	  labelCompleto: 'Devolução de honra'
	},
	{
		codigo: '5',
		labelAbreviado: 'leilao',
		labelCompleto: 'Leilão'
	}
  ];